// 각 카테고리별 페이지를 보여주는 컴포넌트입니다
import React from 'react';
import { useParams } from 'react-router-dom';
import { categories } from '../data/categories';
import SEOHead from './SEOHead';

function CategoryPage() {
  // URL에서 카테고리 이름 가져오기 (예: /category/animals의 'animals')
  const { categoryName } = useParams();
  
  // 카테고리 정보 찾기
  const category = categories[categoryName];
  
  // 카테고리가 없으면 오류 메시지 표시
  if (!category) {
    return (
      <div>
        <SEOHead />
        <h1>카테고리를 찾을 수 없습니다</h1>
        <p>요청하신 카테고리가 존재하지 않습니다.</p>
      </div>
    );
  }

  return (
    <div>
      {/* SEO 헤드 태그 적용 */}
      <SEOHead category={category} />
      
      {/* 카테고리 페이지 내용 */}
      <div className="category-page">
        <h1>{category.name} 플래시카드</h1>
        <p>{category.description}</p>
        <p>총 {category.itemCount}개의 카드가 있습니다.</p>
        
        {/* 여기에 실제 플래시카드 컴포넌트를 넣으면 됩니다 */}
        <div className="flashcard-container">
          <p>플래시카드가 여기에 표시됩니다.</p>
        </div>
      </div>
    </div>
  );
}

export default CategoryPage;